module.exports = __webpack_public_path__ + "static/media/Bitmap@2x.8d7cb9c8.png";